import TableHeading from '@/components/Common/TableHeading.vue'
import EmptyList from '@/components/Common/EmptyList.vue'

const dashboard = {
  components: { EmptyList, TableHeading },
  viewtitle: 'Sites',
  remainingdays: 'trial days left'
}

export default dashboard
